<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-button size="small" type="primary" :class="[theme]" @click="handleAdd" v-if="isAdmin">添加套餐</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading">
				<el-table-column prop="packagesName" label="运营商套餐名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="sjtxPackagesName" label="云企通套餐名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="dxtPrice" label="迪信通价格" align="center">
					<template #default="scope">
						<span>{{ scope.row.dxtPrice }}元</span>
					</template>
				</el-table-column>
				<el-table-column prop="sjtxPrice" label="云企通价格" align="center">
					<template #default="scope">
						<span>{{ scope.row.sjtxPrice }}元</span>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="套餐类型" align="center">
					<template #default="scope">
						<span v-if="scope.row.type == 0">整月套餐</span>
						<span v-if="scope.row.type == 1">首月上下半月套餐，次月整月</span>
					</template>
				</el-table-column>
				<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="190" align="center">
					<template #default="scope">
						<el-button size="small" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
							@click="handleDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="title" v-model="addVisible" width="520px" @close="closeDialog">
			<el-form label-width="130px" :model="addForm" ref="editForm">
				<el-form-item label="运营商套餐名称" prop="packagesName">
					<el-input size="small" v-model="addForm.packagesName" placeholder="请输入运营商套餐名称"></el-input>
				</el-form-item>
				<el-form-item label="云企通套餐名称" prop="sjtxPackagesName">
					<el-input size="small" v-model="addForm.sjtxPackagesName" placeholder="请输入云企通套餐名称"></el-input>
				</el-form-item>
				<el-form-item label="迪信通价格" prop="dxtPrice">
					<el-input size="small" type="number" v-model="addForm.dxtPrice" placeholder="请输入迪信通价格">
						<template v-slot:append>
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="云企通价格" prop="sjtxPrice">
					<el-input size="small" type="number" v-model="addForm.sjtxPrice" placeholder="请输入云企通价格">
						<template v-slot:append>
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="套餐类型" prop="type">
					<el-radio-group v-model="addForm.type">
						<el-radio :label="0">整月套餐</el-radio>
						<el-radio :label="1">首月上下半月套餐，次月整月</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '添加'"
						@click="submitAdd">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '修改'"
						@click="submitUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDxtPackagesOfNumber,
		addDxtPackagesOfNumber,
		updateDxtPackagesOfNumber,
		deleteDxtPackagesOfNumber
	} from '../../api/dijia.js';
	export default {
		name: 'DxtPackagesManagement',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {},
				title: '添加',
				tableData: [],
				addForm: {
					packagesName: '',
					sjtxPackagesName: '',
					dxtPrice: '',
					sjtxPrice: '',
					type: 0
				},
				addVisible: false,
				isAdmin: false,
				isCompany: false,
				isAgent: false
			};
		},

		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'company') {
				this.isCompany = true;
			}
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			this.getData();
		},
		methods: {
			getData() {
				this.loading = true;
				getDxtPackagesOfNumber().then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAdd() {
				this.title = '添加';
				this.addVisible = true;
				this.addForm = {
					packagesName: '',
					sjtxPackagesName: '',
					dxtPrice: '',
					sjtxPrice: '',
					type: 0
				};
			},
			handleEdit(row) {
				this.title = '修改';
				this.addVisible = true;
				this.addForm = {
					id: row.id,
					packagesName: row.packagesName,
					sjtxPackagesName: row.sjtxPackagesName,
					dxtPrice: row.dxtPrice,
					sjtxPrice: row.sjtxPrice,
					type: row.type
				};
			},
			submitAdd() {
				if (!this.addForm.packagesName) {
					this.$message.error('运营商套餐名称不能为空');
					return;
				}
				if (!this.addForm.dxtPrice && this.addForm.dxtPrice !== 0) {
					this.$message.error('迪信通价格不能为空');
					return;
				}
				if (!this.addForm.sjtxPrice && this.addForm.sjtxPrice !== 0) {
					this.$message.error('云企通价格不能为空');
					return;
				}
				if (this.addForm.type === null || this.addForm.type === undefined) {
					this.$message.error('套餐类型不能为空');
					return;
				}
				let data = {
					packagesName: this.addForm.packagesName,
					sjtxPackagesName: this.addForm.sjtxPackagesName,
					dxtPrice: this.addForm.dxtPrice,
					sjtxPrice: this.addForm.sjtxPrice,
					type: this.addForm.type
				};
				addDxtPackagesOfNumber(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('添加成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			submitUpload() {
				let data = {
					id: this.addForm.id,
					packagesName: this.addForm.packagesName,
					sjtxPackagesName: this.addForm.sjtxPackagesName,
					dxtPrice: this.addForm.dxtPrice,
					sjtxPrice: this.addForm.sjtxPrice,
					type: this.addForm.type
				};
				updateDxtPackagesOfNumber(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('修改成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			closeDialog() {
				this.addVisible = false;
			},
			handleDelete(row) {
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						deleteDxtPackagesOfNumber(row.id).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}
</style>
